import { makeObservable, flow, observable, action } from "mobx";
import { toast } from "sonner";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { Check, HeartOff } from "lucide-react";

import { LoaderIcon } from "@/components/icons/LoaderIcon";

import RemoveItemFromWatchSchema from "@/areas/inventory/schemas/RemoveItemFromWatchSchema";

export default class RemoveItemFromWatchlistStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
    });

    this.parentStore = parentStore;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save(data, options) {
    let toastId;
    try {
      this.processing = true;

      const parseResult = RemoveItemFromWatchSchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      toastId = toast(
        <div className="flex w-full items-center gap-2">
          <HeartOff className="size-4 text-primary" />
          <div className="flex flex-grow flex-col">
            <span className="text-base">Watchlist</span>
            <span>Removing item from your watchlist</span>
          </div>
          <LoaderIcon className="h-5 w-5 text-primary" />
        </div>,
        {
          duration: Infinity,
        }
      );

      const response = yield api.delete(ApiRoutes.forItemWatchlist(data.id), { data });
      this.visible = false;

      toast(
        <div className="flex w-full items-center gap-2">
          <HeartOff className="size-4 text-primary" />
          <div className="flex flex-grow flex-col">
            <span className="text-base">Watchlist</span>
            <span>Item removed from watchlist successfully</span>
          </div>
          <Check className="h-5 w-5 text-green-600" />
        </div>,
        {
          id: toastId,
          duration: 4000,
        }
      );
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while removing item from watchlist", {
        description: e.response?.data?.message ?? e.response?.message ?? "Unexpected error, please try again later.",
        id: toastId,
        duration: 4000,
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
